import { render, staticRenderFns } from "./academic_examination_ftpaper.vue?vue&type=template&id=c0860762&scoped=true&"
import script from "./academic_examination_ftpaper.vue?vue&type=script&lang=js&"
export * from "./academic_examination_ftpaper.vue?vue&type=script&lang=js&"
import style0 from "./academic_examination_ftpaper.vue?vue&type=style&index=0&id=c0860762&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0860762",
  null
  
)

export default component.exports